import api from '../api/api';

const host = process.env.REACT_APP_API_URL

export async function getUsersByRole(role) {
    const userResponse = await api.get(host + '/api/users?roleId=' + role, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    });

    return userResponse.data;
}

export async function getAllUsers() {
    const userResponse = await api.get(host + '/api/users', {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    });

    return userResponse.data;
}

export async function createUser(user) {
    const userResponse = await api.post(
        host + '/api/users',
        user,
        {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
                'Content-Type': 'application/json'
            }
        }
    );

    return userResponse.data;
}

export async function updateUser(user) {
    const userResponse = await api.put(
        host + '/api/users/' + user.id,
        user,
        {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
                'Content-Type': 'application/json'
            }
        }
    );

    return userResponse.data;
}

export async function deleteUserById(id) {
    const userResponse = await api.delete(host + '/api/users/' + id, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    });

    return userResponse.data;
}

export async function getAllRoles() {
    const roleResponse = await api.get(host + '/api/roles', {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    });

    return roleResponse.data;
}

export async function getProductNames() {
    const response = await api.get(host + '/api/products/names', {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    })
    return response.data;
}

export async function getAllProducts() {
    const response = await api.get('/api/products', {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export async function createProduct(product) {
    const response = await api.post('/api/products', product, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export async function bulkApplyProducts(changedProducts) {
    const response = await api.post('/api/products/bulk-apply', changedProducts, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export async function deleteProducts(idsToDelete) {
    await api.delete('/api/products', {
        data: { ids: idsToDelete },
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    });
}

export async function getProductInstances(userId, month, year) {
    const productIntancesUrl = new URL(host + '/api/product-instance');
    productIntancesUrl.search = new URLSearchParams({
        userId: userId,
        month: month,
        year: year
    }).toString();
    const response = await api.get(productIntancesUrl, {
        headers: {
            'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
            'Content-Type': 'application/json'
        }
    });
    return response.data;
}

export async function bulkApplyProductInstances(updates) {
    const response = await api.post(`${host}/api/product-instance/bulk-apply`,
        { updates },
        {
            headers: {
                'Authorization': `Bearer ${localStorage.getItem('jwtToken')}`,
                'Content-Type': 'application/json'
            }
        }
    );
    return response.data;
}